import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IGroupItemsDetailResponse, IGroupItemsDetailResponseData } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useGroupItemsDetailAPI = () => {
  const [groupItemDetail, setGroupItemDetail] = useState<IGroupItemsDetailResponseData>({
    parent_details: {
      type: "",
      selected_item_id: "",
      selected_item_name: "",
    },
    child_details: [
      {
        type: "",
        selected_item_id: "",
        selected_item_name: "",
      },
    ],
    status: "",
    created_by: "",
    item_group_id: "",
    updated_by: "",
  });
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        await axios
          .get(INVENTORY_MODULE?.GROUP_ITEMS_DETAIL?.baseURL + `${id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IGroupItemsDetailResponse>) => {
            if (res.data.status === true) {
              setGroupItemDetail(res.data.data);
            } else {
              setGroupItemDetail(null);
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        setGroupItemDetail(null);
        if (axios.isAxiosError(error)) {
          captureError(error);
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [configuration],
  );

  return { execute, groupItemDetail };
};
